import { render, staticRenderFns } from "./HomeFeedHeroChild.vue?vue&type=template&id=6a25d976&scoped=true"
import script from "./HomeFeedHeroChild.vue?vue&type=script&lang=js"
export * from "./HomeFeedHeroChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a25d976",
  null
  
)

export default component.exports